import React, { useState } from 'react'
import Style from './PeykDiscountCode.module.css'
import { errorToast, succToast } from '../../../../Toast/Toast'
const PeykDiscountCode = () => {
  const [discountState,setDiscountState]=useState()
  const submitDiscount=()=>{
    if(!discountState){
      errorToast('ابتدا کد را وارد کنید!')
      return
    }
    succToast('مبحث کد تخفیف توسعه داده نشده')

  }
  return (
    <div className={Style.componentHolder}>
      <input type="text" placeholder='کد تخفیف خود را وارد کنید!' onChange={e=>setDiscountState(e.target.value)}/>
      <button onClick={submitDiscount}>ثبت</button>
    </div>
  )
}

export default PeykDiscountCode